import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

const AccessDenied = () => {
  return (
    <Paper sx={{ p: 4, textAlign: 'center', maxWidth: 600, mx: 'auto', mt: 4 }}>
      <LockIcon sx={{ fontSize: 60, color: 'error.main', mb: 2 }} />
      <Typography variant="h4" component="h1" gutterBottom>
        Brak dostępu
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Nie masz uprawnień do wyświetlenia tej strony. Skontaktuj się z administratorem, jeśli uważasz, że powinieneś mieć dostęp.
      </Typography>
    </Paper>
  );
};

export default AccessDenied;
